// extracted by mini-css-extract-plugin
export default {"paymentSection":"F--z","disabled":"G--z"};